<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="员工姓名" prop="name" style="margin-right:15px">
        <!--              <el-input v-model="form.name" placeholder="请输入姓名" />-->
        <staffSelect ref="staffSelect" @setStaff="setStaff" @getRoleList="getRoleList" />
      </el-form-item>
      <el-form-item label="登录账号" prop="phone" style="margin-right:15px">
        <el-input v-model="form.phone" placeholder="请输入登录账号" />
      </el-form-item>
      <el-form-item label="所属部门" prop="groupName" style="margin-right:15px">
        <el-input v-model="groupName" readonly />
      </el-form-item>
      <el-form-item label="角色" prop="roleCodeList" style="margin-right:15px">
        <el-checkbox-group v-model="form.roleCodeList">
          <el-checkbox v-for="role in roleList" :key="role.code" :label="role.code" border>
            <span style="float:left">{{ role.roleName }}</span>
            <span style="float: right ; color: #8492a6; font-size: 12px">&nbsp;&nbsp;{{ role.branchName }}</span>
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import staffSelect from "./staffSelect";
export default {
  name: 'PartyAdd',
  components: {
    staffSelect
  },
  data() {
    // 校验手机号
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^[1][0-9]{10}$/
      if (!phoneReg.test(value)) {
        callback(new Error('格式有误'))
      } else {
        callback()
      }
    }
    return {
      staffs:[],
      groupName:"",
      form: {
        code:'',
        partyType: 'STAFF',
        branchCode: '',
        departmentCode: '',
        teamCode: '',
        name: '',
        phone: '',
        roleCodeList: []
      },
      rules: {
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ]
      },
      roleList: [],
      listQuery: {
        partyType: 'STAFF',
        name: '',
        phone: '',
        roleCode: '',
        isQueryRole: 1,
        gmtCreatedStart: '',
        gmtCreatedEnd: '',
        branchCode: '',
        departmentCode: '',
        teamCode: '',
        pageNum: 1,
        pageSize: 20,
        sortField: '',
        sortType: '',
        total: 0
      }
    }
  },
  created() {
    // this.getRoleList();
  },
  methods: {




    setStaff(value){
      this.form.name = value.name;
      this.form.code = value.code;
      this.form.phone = value.phone;
      let groupName = '';
      if(value.branchName){
        groupName= value.branchName;
      }
      if(value.departmentName){
        groupName +="/";
        groupName +=value.departmentName
      }
      if(value.teamName){
        groupName +="/";
        groupName +=value.teamName
      }
      this.groupName = groupName
      this.form.branchCode = value.branchCode;
      this.form.departmentCode = value.departmentCode;
      this.form.teamCode = value.teamCode;
    },
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const data = this.form
          const rLoading = this.openLoading();
          request({ url: '/ntocc-basic-api/userLogin', method: 'post', data }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherAddMethod')
          }).then(() => {
              this.$refs.staffSelect.setSelectValue('')
              this.groupName = "";
              this.$refs['form'].resetFields();
            })
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'add')
    },

    // 查询角色列表
    getRoleList(branchCode) {
      request({ url: `/ntocc-basic-api/role`, method: 'get', params: { 'type': 0,'branchCode':branchCode }}).then(response => {
        this.roleList = response.data.records
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin:15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
